import { render, staticRenderFns } from "./CreateClass.vue?vue&type=template&id=74e02b4c"
import script from "./CreateClass.vue?vue&type=script&lang=js"
export * from "./CreateClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports